
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import '../../../node_modules/core-js/modules/es.array.filter.js';
import '../../../node_modules/core-js/modules/es.array.find.js';
import '../../../node_modules/core-js/modules/es.array.map.js';
import '../../../node_modules/core-js/modules/es.object.to-string.js';

var getVisibleAccessors = function getVisibleAccessors(columns) {
  return columns.filter(function (column) {
    return !column.hidden;
  }).map(function (column) {
    return column.accessor;
  });
};
var getDefaultAccessor = function getDefaultAccessor(columns) {
  var _columns$find$accesso, _columns$find;
  var visibleAccessors = getVisibleAccessors(columns);
  return (_columns$find$accesso = (_columns$find = columns.find(function (column) {
    return column.isDefaultAccessor;
  })) === null || _columns$find === void 0 ? void 0 : _columns$find.accessor) !== null && _columns$find$accesso !== void 0 ? _columns$find$accesso : visibleAccessors[0];
};

export { getDefaultAccessor, getVisibleAccessors };
//# sourceMappingURL=helpers.js.map
